import { useIntl } from "react-intl";
import z from "zod";

import { successToast } from "../../../../atoms/toast";
import { FormInput } from "../../../../form/RHF-fields/form-input";
import { Prompt } from "../../../../molecules/prompt";
import { useDataTableSettingsContext } from "../../../context/data-table-settings-context";
import { useApplyPreferenceProfile } from "../hooks/apply-preference-profile";
import { useAddDataTablePreferenceMutation } from "../mutation";

export function AddDataTablePreferenceAction() {
  const intl = useIntl();

  const { showAddPreference, setShowAddPreference, focusTrigger } =
    useDataTableSettingsContext();

  const applyPreferenceProfile = useApplyPreferenceProfile();

  const mutation = useAddDataTablePreferenceMutation();

  return (
    <Prompt
      key={`add-data-table-preference-${showAddPreference}`}
      open={showAddPreference}
      onOpenChange={(open) => {
        setShowAddPreference(open);
        focusTrigger();
      }}
      title={intl.formatMessage({
        id: "data-table.preferences.save-profile.title",
        defaultMessage: "Uložit nastavení tabulky",
      })}
      formSchema={z.object({
        name: z.string(),
      })}
      onDecision={async ({ confirmed, data }) => {
        if (!confirmed) return;

        const result = await mutation.mutateAsync(data.name);

        successToast(
          intl.formatMessage({
            id: "data-table.preferences.save-profile.success",
            defaultMessage: "Přehled byl úspěšně uložen",
          }),
        );

        setShowAddPreference(false);

        void applyPreferenceProfile({ id: result.id, name: result.name });
      }}
      content={
        <FormInput
          name="name"
          label={intl.formatMessage({
            id: "data-table.preferences.save-profile.name",
            defaultMessage: "Název nastavení",
          })}
        />
      }
    />
  );
}
